class FaqAccordionItem extends HTMLElement {
  constructor() {
    super();
    this.el = this.querySelector('details');
    this.summary = this.el.querySelector('summary');
    this.content = this.el.querySelector('.faq-accordion__answer');
    this.animation = null;
    this.isClosing = false;
    this.isExpanding = false;
    this.duration = 300;
    this.oneOpen = true;

    const accordion = new AccordionGlobals();
    this.summary.addEventListener('click', (e) => accordion.onClick(e, this));
  }

}

customElements.define('faq-accordion-item', FaqAccordionItem);
